enum SCOPE_ACTIONS {
	INCLUDE = 'include',
	EXCLUDE = 'exclude'
}

export { SCOPE_ACTIONS };
